import React from "react";

/**
 * ClanIcon component - A clan icon that can be used as a default avatar
 *
 * @param {Object} props - Component props
 * @param {string} props.color - Primary color for the icon (default: currentColor)
 * @param {string} props.size - Size of the icon (default: 100%)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @returns {JSX.Element} SVG icon component
 */
const ClanIcon = ({
  color = "currentColor",
  size = "100%",
  className = "",
  style = {},
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      width={size}
      height={size}
      className={className}
      style={{ fill: color, ...style }}
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M38.121,76.102l4.08,4.081c0.892,0.891 1.393,2.1 1.393,3.361c-0,1.261 -0.501,2.47 -1.393,3.361c-0.409,0.41 -0.833,0.833 -1.243,1.243c-0.891,0.892 -2.1,1.393 -3.361,1.393c-1.261,-0 -2.47,-0.501 -3.361,-1.393l-6.912,-6.912l-12.222,12.223c-2.055,2.055 -5.387,2.055 -7.441,-0l-1.12,-1.119c-2.055,-2.055 -2.055,-5.387 0,-7.442l12.223,-12.222l-7.184,-7.183c-0.891,-0.892 -1.392,-2.101 -1.392,-3.362c0,-1.26 0.501,-2.469 1.392,-3.361l1.243,-1.243c0.892,-0.891 2.101,-1.392 3.362,-1.392c1.26,-0 2.469,0.501 3.361,1.392l4.352,4.352l40.272,-52.601c0.167,-0.218 0.414,-0.361 0.686,-0.398l28.97,-3.871c0.321,-0.043 0.642,0.066 0.871,0.295c0.228,0.228 0.337,0.55 0.294,0.87l-3.871,28.97c-0.037,0.272 -0.18,0.519 -0.398,0.686l-52.601,40.272Z"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M69.843,53.704l-18.609,14.248l10.645,8.15l-4.08,4.081c-0.892,0.891 -1.392,2.1 -1.392,3.361c-0,1.261 0.5,2.47 1.392,3.361c0.41,0.41 0.833,0.833 1.243,1.243c0.891,0.892 2.1,1.393 3.361,1.393c1.261,-0 2.47,-0.501 3.361,-1.393l6.912,-6.912l12.222,12.223c2.055,2.055 5.387,2.055 7.442,-0l1.119,-1.119c2.055,-2.055 2.055,-5.387 -0,-7.442l-12.222,-12.222l7.183,-7.183c0.891,-0.892 1.392,-2.101 1.392,-3.362c0,-1.26 -0.501,-2.469 -1.392,-3.361l-1.243,-1.243c-0.892,-0.891 -2.101,-1.392 -3.361,-1.392c-1.261,-0 -2.47,0.501 -3.362,1.392l-4.352,4.352l-6.259,-8.175Zm-39.965,-2.103l19.178,-25.049l-13.226,-17.274c-0.167,-0.218 -0.413,-0.361 -0.686,-0.398l-28.97,-3.871c-0.32,-0.043 -0.642,0.066 -0.87,0.295c-0.229,0.228 -0.338,0.55 -0.295,0.87l3.872,28.97c0.036,0.272 0.179,0.519 0.397,0.686l20.6,15.771Z"
      />
    </svg>
  );
};

export default ClanIcon;
